import { Box, BoxProps, forwardRef } from '@chakra-ui/react';

import { createUseVariantStyle } from '@bonusly/ds-hooks';
import { ArrowRightOutline } from '@bonusly/ds-icon';

import { useAlertContext } from '../context';

const useVariantStyle = createUseVariantStyle({
	size: {
		sm: {
			top: 1.5,
			right: 2,
		},
		md: {
			top: 3,
			right: 3,
		},
	},
});

const AlertArrow = forwardRef<BoxProps, 'button'>((props, ref) => {
	const { size } = useAlertContext();
	const styles = useVariantStyle({ size });

	return (
		<Box color="text.soft" lineHeight={0} p={0.5} pos="absolute" ref={ref} {...styles} {...props}>
			<ArrowRightOutline size="sm" />
		</Box>
	);
});

AlertArrow.displayName = 'AlertArrow';

export { AlertArrow };
